import styled from 'styled-components';

export const LocalesContainer = styled.div`
  padding: 0;
`;

export const Pad = styled.span`
  padding: 0 0.5em;
  color: #d8d1d1;
`;
